import React from 'react';
import { useModalDispatch, useScreenSizeState } from '@olo-web/client-state';
import { EModalTypes } from '@olo-web/types/enums';
import { isFeatureEnabledForMerchant } from '@olo-web/utils/common/functions';
import { Button } from '@chakra-ui/react';
import { useMerchant } from '@olo-web/domain/merchants/queries';
import { useFeatureFlags } from '@olo-web/domain/featureFlags/queries';
import { QRScanIcon } from '@olo-web/assets/icons/QRScanIcon.ui';

export const LoyaltyQRCodeButton = () => {
  const modalDispatch = useModalDispatch();
  const { isSmDown } = useScreenSizeState();
  const { data: featureFlags } = useFeatureFlags();
  const { data: merchant } = useMerchant();
  const showQRCodeButton = isFeatureEnabledForMerchant({
    featureEnabled: featureFlags?.loyaltyQRCode.on,
    allowList: featureFlags?.loyaltyQRCode.allow,
    denyList: featureFlags?.loyaltyQRCode.deny,
    merchantId: merchant?.merchantId,
  });

  if (!showQRCodeButton || !isSmDown) return null;

  return (
    <Button
      variant="tertiary"
      rightIcon={<QRScanIcon />}
      colorScheme="black"
      alignItems="center"
      justifyContent="space-between"
      px={4}
      w="100%"
      background={'#FFF'}
      onClick={() =>
        modalDispatch({
          type: 'OPEN_MODAL',
          payload: {
            modalKey: EModalTypes.LOYALTY_QR_CODE,
          },
        })
      }
    >
      Loyalty QR Code
    </Button>
  );
};
